/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertFilter,
    InternalApiAlertFilterFromJSON,
    InternalApiAlertFilterToJSON,
    InternalApiAlertType,
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeToJSON,
    InternalApiNewAlertFilter,
    InternalApiNewAlertFilterFromJSON,
    InternalApiNewAlertFilterToJSON,
    InternalApiOptionalAlertAssignment,
    InternalApiOptionalAlertAssignmentFromJSON,
    InternalApiOptionalAlertAssignmentToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
} from '../models';

export interface AddAlertFilterRequest {
    internalApiNewAlertFilter: InternalApiNewAlertFilter;
}

export interface AssignNextAlertFromFilterRequest {
    filterId: number;
    direction: InternalApiSortDirection;
    orderBy?: AssignNextAlertFromFilterOrderByEnum;
    offset?: Date;
    currentAlertId?: number;
    currentAlertType?: InternalApiAlertType;
}

export interface DeleteAlertFilterRequest {
    id: number;
}

export interface UpdateAlertFilterRequest {
    id: number;
    internalApiNewAlertFilter: InternalApiNewAlertFilter;
}

/**
 * 
 */
export class AlertFilterApi extends runtime.BaseAPI {

    /**
     */
    async addAlertFilterRaw(requestParameters: AddAlertFilterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertFilter>> {
        if (requestParameters.internalApiNewAlertFilter === null || requestParameters.internalApiNewAlertFilter === undefined) {
            throw new runtime.RequiredError('internalApiNewAlertFilter','Required parameter requestParameters.internalApiNewAlertFilter was null or undefined when calling addAlertFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/filters`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiNewAlertFilterToJSON(requestParameters.internalApiNewAlertFilter),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertFilterFromJSON(jsonValue));
    }

    /**
     */
    async addAlertFilter(requestParameters: AddAlertFilterRequest, initOverrides?: RequestInit): Promise<InternalApiAlertFilter> {
        const response = await this.addAlertFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assignNextAlertFromFilterRaw(requestParameters: AssignNextAlertFromFilterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiOptionalAlertAssignment>> {
        if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
            throw new runtime.RequiredError('filterId','Required parameter requestParameters.filterId was null or undefined when calling assignNextAlertFromFilter.');
        }

        if (requestParameters.direction === null || requestParameters.direction === undefined) {
            throw new runtime.RequiredError('direction','Required parameter requestParameters.direction was null or undefined when calling assignNextAlertFromFilter.');
        }

        const queryParameters: any = {};

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = (requestParameters.offset as any).toISOString();
        }

        if (requestParameters.currentAlertId !== undefined) {
            queryParameters['currentAlertId'] = requestParameters.currentAlertId;
        }

        if (requestParameters.currentAlertType !== undefined) {
            queryParameters['currentAlertType'] = requestParameters.currentAlertType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/filters/{filterId}/assignNextAlert`.replace(`{${"filterId"}}`, encodeURIComponent(String(requestParameters.filterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiOptionalAlertAssignmentFromJSON(jsonValue));
    }

    /**
     */
    async assignNextAlertFromFilter(requestParameters: AssignNextAlertFromFilterRequest, initOverrides?: RequestInit): Promise<InternalApiOptionalAlertAssignment> {
        const response = await this.assignNextAlertFromFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteAlertFilterRaw(requestParameters: DeleteAlertFilterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteAlertFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/filters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAlertFilter(requestParameters: DeleteAlertFilterRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteAlertFilterRaw(requestParameters, initOverrides);
    }

    /**
     */
    async findAlertFiltersRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiAlertFilter>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiAlertFilterFromJSON));
    }

    /**
     */
    async findAlertFilters(initOverrides?: RequestInit): Promise<Array<InternalApiAlertFilter>> {
        const response = await this.findAlertFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAlertFilterRaw(requestParameters: UpdateAlertFilterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertFilter>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateAlertFilter.');
        }

        if (requestParameters.internalApiNewAlertFilter === null || requestParameters.internalApiNewAlertFilter === undefined) {
            throw new runtime.RequiredError('internalApiNewAlertFilter','Required parameter requestParameters.internalApiNewAlertFilter was null or undefined when calling updateAlertFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/filters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiNewAlertFilterToJSON(requestParameters.internalApiNewAlertFilter),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertFilterFromJSON(jsonValue));
    }

    /**
     */
    async updateAlertFilter(requestParameters: UpdateAlertFilterRequest, initOverrides?: RequestInit): Promise<InternalApiAlertFilter> {
        const response = await this.updateAlertFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum AssignNextAlertFromFilterOrderByEnum {
    CREATED_TIME = 'CREATED_TIME',
    STATUS_UPDATED_TIME = 'STATUS_UPDATED_TIME'
}
